<template>
  <cleave class="form-control" :value="value" @input="$emit('input', $event)" :options="opt" :placeholder="placeholder" ></cleave>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cleaveOptionDate: {
        date: true,
        datePattern: ['m', 'Y']
      },
      cleaveOptionNumeral: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        delimiter: ' ',
        numeralDecimalMark: ',',
        numeralDecimalScale: 2
      }
    };
  },
  computed: {
    opt() {
      if (this.type === 'date') return { ...this.cleaveOptionDate, ...this.options };
      if (this.type === 'numeral') return { ...this.cleaveOptionNumeral, ...this.options };
      return {};
    }
  }
};
</script>
